// src/math.ts
function isNumber(n) {
  return typeof n === "number";
}
function fp64LowPart(x) {
  return x - Math.fround(x);
}
export {
  fp64LowPart,
  isNumber
};
